import { LightMode, Nightlight, Place, Star } from "@mui/icons-material";
import { Box, Grid, Paper, Rating, Typography } from "@mui/material";

import { IStoreDetailData } from "../models";
import { useNavigate } from "react-router-dom";

function MStoreCard(props: IStoreDetailData) {
  const navigate = useNavigate();

  return (
    <Paper
      elevation={4}
      sx={{ my: 1 }}
      onClick={() => {
        navigate(`/stores/${props.Id}`);
      }}
    >
      <Box p={1}>
        <Typography fontWeight="bold">{props.Name}</Typography>
        <Typography>{props.Area}</Typography>
      </Box>
      <Box display="flex" width="100%" height="200px" position="relative">
        <img
          src={props.Images[0]}
          alt="Store banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" p={1}>
        <Rating
          size="small"
          value={props.Points.avg}
          precision={0.5}
          readOnly
        />
        <Typography fontWeight="bold" sx={{ mx: 1 }}>
          {props.Points.avg}
        </Typography>
      </Box>

      {(!props.Intro || props.Intro !== "") && (
        <Box px={1}>
          <Typography>{props.Intro}</Typography>
        </Box>
      )}

      <Box display="flex" alignItems="center" justifyContent="start" p={1}>
        {props.Budgets.day && props.Budgets.day.min && (
          <Box
            display="flex"
            alignItems="center"
            width="max-content"
            marginRight={1}
          >
            <Box
              borderRadius={25}
              marginRight={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <LightMode fontSize="small" />
            </Box>
            <Typography fontWeight="bold">{`￥${props.Budgets.day.min} ~ ￥${props.Budgets.day.max}`}</Typography>
          </Box>
        )}

        {props.Budgets.night && props.Budgets.night.min && (
          <Box display="flex" alignItems="center" width="max-content">
            <Box
              borderRadius={25}
              marginRight={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Nightlight fontSize="small" />
            </Box>
            <Typography fontWeight="bold">{`￥${props.Budgets.night.min} ~ ￥${props.Budgets.night.max}`}</Typography>
          </Box>
        )}
      </Box>

      {/* <Box sx={{ display: "flex", overflowX: "auto", flexWrap: "nowrap" }}>
        {items.map((item, index) => (
          <Box
            key={index}
            border={1}
            borderRadius={2}
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{ p: 1, m: 1, whiteSpace: "nowrap" }}
          >
            <Typography variant="body1">{item}</Typography>
            <Typography variant="body1" sx={{ whiteSpace: "nowrap" }}>
              From 16,000
            </Typography>
          </Box>
        ))}
      </Box> */}
    </Paper>
  );
}

export default MStoreCard;
